import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTCATEGORY,
  DELETE_PRODUCTCATEGORY,
  UPDATE_PRODUCTCATEGORY,
  ADD_NEW_PRODUCTCATEGORY,
} from "./actionType";

import {
  getProductCategorySuccess,
  getProductCategoryFail,
  deleteProductCategorySuccess,
  deleteProductCategoryFail,
  updateProductCategorySuccess,
  updateProductCategoryFail,
  addProductCategorySuccess,
  addProductCategoryFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getProductCategoryApi,
  updateProductCategoryApi,
  deleteProductCategoryApi,
  addNewProductCategoryApi
} from "../../helpers/backend_helper";

function* getProductCategory({ payload: productCategory }) {
  try {
    const response = yield call(getProductCategoryApi, productCategory);
    yield put(getProductCategorySuccess(GET_PRODUCTCATEGORY, response.data));
  } catch (error) {
    yield put(getProductCategoryFail(GET_PRODUCTCATEGORY, error));
  }
}

function* onUpdateProductCategory({ payload: productCategory }) {
  try {
    const response = yield call(updateProductCategoryApi, productCategory);
    yield put(updateProductCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateProductCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductCategory({ payload: productCategory }) {
  try {
    const response = yield call(deleteProductCategoryApi, productCategory);
    yield put(deleteProductCategorySuccess({ productCategory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductCategory({ payload: productCategory }) {
  try {
    const response = yield call(addNewProductCategoryApi, productCategory);
    yield put(addProductCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductCategory() {
  yield takeEvery(GET_PRODUCTCATEGORY, getProductCategory);
}

export function* watchUpdateProductCategory() {
  yield takeEvery(UPDATE_PRODUCTCATEGORY, onUpdateProductCategory);
}

export function* watchDeleteProductCategory() {
  yield takeEvery(DELETE_PRODUCTCATEGORY, onDeleteProductCategory);
}

export function* watchAddNewProductCategory() {
  yield takeEvery(ADD_NEW_PRODUCTCATEGORY, onAddNewProductCategory);
}

function* productCategorySaga() {
  yield all([
    fork(watchGetProductCategory),
    fork(watchDeleteProductCategory),
    fork(watchUpdateProductCategory),
    fork(watchAddNewProductCategory)
  ]);
}

export default productCategorySaga;
